var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	49790: {
		fallback: () => (() => (__webpack_require__(66830))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.x",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	20458: {
		fallback: () => (() => (__webpack_require__(51567))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.x",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	30076: {
		fallback: () => (Promise.all([__webpack_require__.e(39871), __webpack_require__.e(42380)]).then(() => (() => (__webpack_require__(39871))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	16778: {
		fallback: () => (() => (__webpack_require__(79276))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "jotai/utils",

	},
	71131: {
		fallback: () => (() => (__webpack_require__(91104))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "jotai",

	},
	26157: {
		fallback: () => (Promise.all([__webpack_require__.e(39871), __webpack_require__.e(42380)]).then(() => (() => (__webpack_require__(39871))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	25051: {
		fallback: () => (__webpack_require__.e(9117).then(() => (() => (__webpack_require__(9117))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	10635: {
		fallback: () => (__webpack_require__.e(26114).then(() => (() => (__webpack_require__(26114))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "*",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [49790];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"11598": [
		49790
	],
	"14681": [
		25051,
		10635
	],
	"20458": [
		20458
	],
	"26157": [
		26157
	],
	"30076": [
		30076
	],
	"58394": [
		16778,
		71131
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}